import { Plugin, Utils, LazyMap, } from "@hydrosoft/map-api";
import React from "react";
import { PointGrid } from "./pointGrid";
import { TranslationPrefixContext } from "@hydrosoft/components";
export class PointGridPlugin extends Plugin {
    _ref = { current: undefined };
    _callbacks = [];
    create(element, eventManager) {
        const options = Utils.getAttributes(element.attribs, []);
        return (React.createElement(TranslationPrefixContext.Provider, { value: "pointGrid" },
            React.createElement(PointGrid, { map: new LazyMap(eventManager), ref: this._ref, active: options.active, orderMethod: options.orderMethod, mask: options.mask, style: options.style, label: options.label, rotation: options.rotation, spacing: options.spacing, buffer: options.buffer, offset: options.offset, defaults: options.defaults, afterRender: () => {
                    if (this._ref.current !== undefined) {
                        this._callbacks.forEach((callback) => {
                            callback.call(null, this._ref.current);
                        });
                    }
                } })));
    }
    getLocales(lang) {
        const locales = {
            cs: {
                pointGrid: {
                    title: "Síť bodů",
                    pointCount: "Počet bodů: {count}",
                    rotation: "Natočení: {rotation}",
                    spacing: "Rastr: {spacing}",
                    buffer: "Vzdálenost od hranice: {buffer}",
                    offsetX: "Horizontální posun: {offset}",
                    offsetY: "Vertikální posun: {offset}",
                    order: "Přiřadit čísla",
                    save: "Uložit body",
                },
            },
            en: {
                pointGrid: {
                    title: "Síť bodů",
                    pointCount: "Počet bodů: {count}",
                    rotation: "Natočení: {rotation}",
                    spacing: "Rastr: {spacing}",
                    buffer: "Vzdálenost od hranice: {buffer}",
                    offsetX: "Horizontální posun: {offset}",
                    offsetY: "Vertikální posun: {offset}",
                    order: "Přiřadit čísla",
                    save: "Uložit body",
                },
            },
        };
        return locales[lang];
    }
    afterRender(callback) {
        this._callbacks.push(callback);
    }
}
//# sourceMappingURL=PointGridPlugin.js.map